/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {lazy, Suspense, FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
// import {PrivateRoutes} from './PrivateRoutes'
// import {ErrorsPage} from '../modules/errors/ErrorsPage'
// import {Logout, AuthPage, useAuth} from '../modules/auth'
import {useAuth} from '../modules/auth'
import {App} from '../App'
// import { Version } from '../pages/VersionPage'

const PrivateRoutes = lazy(() => import('./PrivateRoutes').then(m => ({default: m.PrivateRoutes})))
const ErrorsPage = lazy(() => import('../modules/errors/ErrorsPage').then(m => ({default: m.ErrorsPage})))
const Logout = lazy(() => import('../modules/auth').then(m => ({default: m.Logout})))
const AuthPage = lazy(() => import('../modules/auth').then(m => ({default: m.AuthPage})))
const Version = lazy(() => import('../pages/VersionPage').then(m => ({default: m.Version})))

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route element={<App />}>
            <Route path='error/*' element={<ErrorsPage />} />
            <Route path='logout' element={<Logout />} />
            <Route path='version/*' element={<Version />} />
            {currentUser ? (
              <>
                <Route path='/*' element={<PrivateRoutes />} />
                <Route index element={<Navigate to='/dashboard' />} />
              </>
            ) : (
              <>
                <Route path='auth/*' element={<AuthPage />} />
                <Route path='*' element={<Navigate to='/auth' />} />
              </>
            )}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export {AppRoutes}
